import CalendarListItem from "./CalendarListItem";
import { useUpdateUserCalendarMutation } from "../../../../../react-query/userCalendars/mutations";
import { useFetchUserCalendarsQuery } from "../../../../../react-query/userCalendars/queries";

const CalendarList = () => {
  const { data: userCalendarList } = useFetchUserCalendarsQuery();
  const { mutate: updateUserCalendarShow } = useUpdateUserCalendarMutation();

  const handleToggleCalendarShow = (calendarId: number) => {
    updateUserCalendarShow({
      id: calendarId,
      data: { show: !userCalendarList?.find((cal) => cal.id === calendarId)?.show },
    });
  };

  return (
    <div className="flex flex-col gap-0.5">
      {userCalendarList?.map((calendar) => (
        <CalendarListItem
          calendarId={calendar.id}
          isSelected={calendar.show}
          calendarName={calendar.name ?? "No title"}
          color={calendar.backgroundColor}
          onClick={handleToggleCalendarShow}
        />
      ))}
    </div>
  );
};

export default CalendarList;
